export default __webpack_public_path__ + "static/characters_02_LottaPills0-69ee068c0e147a397be2c88aa2a163d8.png";